import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, fmtError } from "../lib/api";
import { useApp } from "../context/AppContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { setUser } = useApp();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      navigate("/");
    } catch (err) {
      setError(fmtError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-teca-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="bg-white rounded-2xl p-4 mb-4 shadow-xl inline-block">
            <img src="/logo-teca.png" alt="TECA Solutions TP" className="h-20 w-auto mx-auto" data-testid="login-logo" />
          </div>
          <h1 className="font-display text-4xl font-extrabold text-white uppercase tracking-tight">
            TECA <span className="text-amber-500">BUILD 360</span>
          </h1>
          <p className="text-slate-400 text-sm mt-2">Calculs • Chantiers • Devis • CRM • Matériel • Risques DROM</p>
          <p className="text-slate-500 text-xs mt-1">Guadeloupe • Martinique • Guyane</p>
        </div>
        <form onSubmit={submit} className="bg-card rounded-2xl p-6 shadow-2xl space-y-4" data-testid="login-form">
          <div>
            <label className="text-xs font-bold uppercase tracking-wide text-muted-foreground">E-mail</label>
            <Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-1 h-13 py-3.5 text-base" placeholder="vous@teca.fr" autoComplete="email" />
          </div>
          <div>
            <label className="text-xs font-bold uppercase tracking-wide text-muted-foreground">Mot de passe</label>
            <Input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-1 py-3.5 text-base" autoComplete="current-password" />
          </div>
          {error && <div data-testid="login-error" className="text-sm font-semibold text-red-600 bg-red-50 dark:bg-red-950 border border-red-300 rounded-lg p-3">{error}</div>}
          <Button data-testid="login-submit" type="submit" disabled={loading}
            className="w-full h-14 text-base font-bold bg-amber-500 hover:bg-amber-400 text-slate-900">
            {loading ? "Connexion…" : "SE CONNECTER"}
          </Button>
          <div className="text-center">
            <Link to="/forgot-password" data-testid="forgot-password-link" className="text-sm text-amber-600 font-semibold hover:underline">
              Mot de passe oublié ?
            </Link>
          </div>
        </form>
        <p className="text-center text-slate-500 text-xs mt-6">TECA SOLUTIONS TP — Accès réservé</p>
      </div>
    </div>
  );
}
